export default __webpack_public_path__ + "static/media/biceps.ba7a64e9.svg";